import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import detectRegion from '../config/region';
import { takePrefetched } from '../api/prefetch';

// Translations live in public/locales and are fetched on demand so the
// ~180KB of locale JSON stays out of the JS bundles entirely. Only the
// active language is downloaded.
const lazyBackend = {
  type: 'backend',
  init() {},
  read(language, namespace, callback) {
    const url = `${process.env.PUBLIC_URL}/locales/${language}.json`;
    // public/index.html may already be fetching this file
    const prefetched = takePrefetched(new URL(url, window.location.href).toString());
    (prefetched ? prefetched.catch(() => fetch(url)) : fetch(url))
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load locale ${language}: ${res.status}`);
        return res.json();
      })
      .then((data) => callback(null, data))
      .catch((error) => callback(error, null));
  }
};

// Detect default language based on domain using centralized region config
const getDefaultLanguageByDomain = () => {
  return detectRegion().defaultLang;
};

const domainDetector = {
  name: 'domainDetector',
  lookup() {
    return getDefaultLanguageByDomain();
  },
  cacheUserLanguage() {
    // Don't cache domain-based detection
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(domainDetector);

i18n
  .use(lazyBackend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: getDefaultLanguageByDomain(),
    supportedLngs: ['mn', 'ru', 'uz'],
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'domainDetector', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
